import { render, staticRenderFns } from "./RestaurantSettingsDialog.vue?vue&type=template&id=c14f5a76&scoped=true"
import script from "./RestaurantSettingsDialog.vue?vue&type=script&lang=js"
export * from "./RestaurantSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./RestaurantSettingsDialog.vue?vue&type=style&index=0&id=c14f5a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14f5a76",
  null
  
)

export default component.exports